import { ListRetrieveGrupo, Permissao } from '@cei-ufg/ngx-cei-seguranca';

export interface PessoaUsuarioFormState {
  nome: string;
  cpf: string;
  login: string;
  email: string;
  password: string;
  is_active: boolean;
  is_staff: boolean;
  user_permissions: Permissao[];
  groups: ListRetrieveGrupo[];
  fotoUrl?: string | null;
}

export const emptyPessoaUsuarioForm = (): PessoaUsuarioFormState => ({
  nome: '',
  cpf: '',
  login: '',
  email: '',
  password: '',
  is_active: true,
  is_staff: false,
  user_permissions: [],
  groups: [],
  fotoUrl: null,
});
